import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';

/**
 * 発注ステータスの一括更新ユースケース
 */
export class UpdateOrderStatusUseCase {
  /**
   * 発注ステータスの一括更新
   * @param repository - リポジトリ
   * @param orderIds - 発注ID
   * @param orderStatus - 発注ステータス
   */
  public async Execute(repository: OrderRepository, orderIds: string[], orderStatus: string): Promise<INetworkResult<string[], Error>> {
    try {
      const response = await repository.updateOrderStatus({
        putOrderInfo: {
          orderIds: orderIds,
          orderStatus: orderStatus,
        },
      });
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          throw response.status.error;
        default:
          throw new Error('Invalid status');
      }

      // TODO: 2024/6/25 responseの型がバックエンドとopenapiで合っておらず、今はいらないのでコメントアウトしておく
      // const result = UpdateOrderAdapter.adaptForResponse(response.status.data);
      return {
        status: {
          type: 'success',
          data: [], // TODO: 2024/6/25 responseの型がバックエンドとopenapiで合っておらず、今はいらないのでコメントアウトしておく
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取得に失敗しました'),
        },
      };
    }
  }
}
